<template>
  <v-container fluid>
    <ValidationObserver ref="obs" v-slot="{ invalid }">
        <v-card
          class="d-flex justify-center flex-column mx-auto my-2 flat"
          width="1200"
          color="#fff"
        >
          <v-card-title class="d-flex justify-center pa-0 my-2">
            証明書発行申請入力フォーム編集
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="d-flex flex-column">
            <v-row dense>
              <v-col cols="12" class="d-flex mb-2">
                <v-row>
                  <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="d-flex">
                    <v-icon>$cet_required</v-icon><div class="ml-2">対象ユーザー区分選択</div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                      </template>
                      <div>申請を行うユーザー区分を選択してください</div>
                    </v-tooltip>
                  </v-col>  
                  <v-col cols="4" sm="3" md="3" lg="3" xl="3" class="d-flex">
                    <v-checkbox v-model="selectedUserKbn"
                      label="生徒"
                      value="0"
                      class="mt-0"
                      hide-details="auto"
                      :disabled="!create"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4" sm="3" md="3" lg="3" xl="3" class="d-flex">
                    <v-checkbox v-model="selectedUserKbn"
                      label="保護者"
                      value="1"
                      class="mt-0"
                      hide-details="auto"
                      :disabled="!create"
                    ></v-checkbox>
                  </v-col>
                  <v-col v-if="!create" cols="4" sm="3" md="3" lg="3" xl="3" class="d-flex justify-end">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small color="accent" v-bind="attrs" v-on="on" class="ma-2 black--text" @click="onClickCopyTemplate">コピー</v-btn>
                      </template>
                      <div>内容をコピーして新しい申請フォーマットを作成します</div>
                      <div>※添付ファイルは引継ぎません</div>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            
            <v-divider></v-divider>
            <v-row dense v-if="create">
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="d-flex my-4 justify-end">
                <v-autocomplete
                  v-model="editAllowIds"
                  label="共同編集者"
                  placeholder="共同編集者"
                  :items="teacherList"
                  outlined
                  dense
                  multiple
                  deletable-chips
                  clearable
                  small-chips
                  hide-details="auto"
                  background-color="white"
                ></v-autocomplete>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                  </template>
                  <div>登録した申請入力フォームについて共同編集する</div>
                  <div>全教員の中から選択して設定する事ができます。</div>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="d-flex my-4 justify-end align-center">
                <v-btn color="green" small class="ma-2 black--text hidden-xs-only" @click="viewEditAllowIdSetDialog = true">
                  ⇐指定グループから設定
                </v-btn>
                <v-btn color="green" small class="ma-2 black--text d-sm-none" @click="viewEditAllowIdSetDialog = true">
                  ↑設定
                </v-btn>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                  </template>
                  <div>指定グループに含まれる教員を共同編集者へ設定します。</div>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="d-flex my-4 justify-end">
                <v-autocomplete
                  v-model="noticeIds"
                  label="通知先"
                  placeholder="通知先"
                  :items="teacherIncludeList"
                  outlined
                  dense
                  multiple
                  deletable-chips
                  clearable
                  small-chips
                  hide-details="auto"
                  background-color="white"
                ></v-autocomplete>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                  </template>
                  <div>申請や変更があった際の通知・メール送信先を</div>
                  <div>全教員の中から選択して設定する事ができます。</div>
                  <div>※学級担任には自動で送信されます。</div>
                </v-tooltip>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="d-flex my-4 justify-end align-center">
                <v-btn color="green" small class="ma-2 black--text hidden-xs-only" @click="viewNoticeIdSetDialog = true">
                  ⇐指定グループから設定
                </v-btn>
                <v-btn color="green" small class="ma-2 black--text d-sm-none" @click="viewNoticeIdSetDialog = true">
                  ↑設定
                </v-btn>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
                  </template>
                  <div>指定グループに含まれる教員を通知先へ設定します。</div>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <ValidationProvider name="並び順" rules="required|numeric|max:5" v-slot="{ errors }">
                  <v-row  no-gutters>
                    <v-col class="pr-0" cols="6" sm="3">
                      <v-text-field
                        v-model="orderNo"
                        prepend-icon="$cet_required"
                        label="並び順"
                        outlined
                        class="number-input pr-2"
                        :error-messages="errors[0]"
                        dense
                        :counter="5"
                        hide-details="auto"
                        @blur="orderNo=formatOrderNo(orderNo)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <ValidationProvider name="名称" rules="required|max:50" v-slot="{ errors }">
              <v-row dense>
                <v-col cols="12" class="d-flex mb-0">
                  <v-text-field
                    v-model="title"
                    prepend-icon="$cet_required"
                    label="名称"
                    placeholder=""
                    :error-messages="errors[0]"
                    outlined
                    dense
                    :counter="50"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </ValidationProvider>
            <ValidationProvider name="説明" rules="required|max:3000" v-slot="{ errors }">
              <v-row dense>
                <v-col cols="12" class="d-flex mb-0">
                  <v-textarea
                    v-model="body"
                    prepend-icon="$cet_required"
                    label="説明"
                    placeholder=""
                    :error-messages="errors[0]"
                    outlined
                    dense
                    auto-grow
                    :counter="3000"
                    hide-details="auto"
                  ></v-textarea>
                </v-col>
              </v-row>
            </ValidationProvider>

            <ValidationProvider name="公開開始日" rules="required" v-slot="{ errors }">
              <v-row dense>
                <v-col class="d-flex mb-2" cols="6" sm="5">
                  <v-text-field
                    v-model="openDate"
                    prepend-icon="$cet_required"
                    label="公開開始日"
                    placeholder=""
                    type="datetime-local"
                    :error-messages="errors[0]"
                    outlined
                    dense
                    hide-details="auto"
                    :disabled="lockOpenDateFlg"
                  >
                  </v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        color="green"
                        v-bind="attrs"
                        v-on="on"
                        small
                        class="black--text ml-2 mt-1 hidden-xs-only"
                        @click="setFastOpen"
                        :disabled="lockOpenDateFlg"
                      >３分後に設定</v-btn>
                    </template>
                    <span>公開開始日に現在時刻の３分後を設定します</span>
                  </v-tooltip>
                </v-col>
                <v-col class="d-flex mb-3 justify-end d-sm-none" cols="12">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="green"
                        v-bind="attrs"
                        v-on="on"
                        small
                        class="black--text"
                        @click="setFastOpen"
                        :disabled="lockOpenDateFlg"
                      >３分後に設定</v-btn>
                    </template>
                    <span>公開開始日に現在時刻の３分後を設定します</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </ValidationProvider>

            <ValidationProvider name="公開終了日" rules="required|datehourAfter:@公開開始日" v-slot="{ errors }">
              <v-row dense>
                <v-col class="d-flex mb-2" cols="6" sm="4">
                  <v-text-field
                    v-model="closeDate"
                    prepend-icon="$cet_required"
                    label="公開終了日"
                    placeholder=""
                    type="datetime-local"
                    :error-messages="errors[0]"
                    outlined
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </ValidationProvider>
            <v-divider></v-divider>
            <v-row dense>
              <v-col cols="12" class="d-flex my-3">
                <v-icon>$cet_required</v-icon><div class="ml-2">設問</div>
              </v-col>
            </v-row>

            <!-- 設問未設定時 -->
            <v-card v-if="!questionListStudent.length" class="ml-0 mt-0 mb-4">
              <div class="ml-2 mt-2">
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-center text-h6 red--text">
                    設問がありません
                  </v-col>
                </v-row>
              </div>
            </v-card>

          <v-expansion-panels multiple>
            <v-expansion-panel style="background-color: #CCFFCC;">
              <v-expansion-panel-header class="">
                <div style="font-size:x-large">生徒・保護者向け入力項目</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>

                <!-- 明細定義 -->
                <v-card v-for="(question, index) in questionListStudent" :key="question.id" class="ml-0 mt-0 mb-4">
                
                  <!-- 文章回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '0'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListStudent, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <!-- 設問 -->
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <ValidationProvider name="回答文字数制限" rules="required|numeric|max:4" v-slot="{ errors }">
                      <v-row  no-gutters>
                        <v-col cols="12" class="pr-0">
                          <v-text-field
                            v-model="question.charLimit"
                            prepend-icon="$cet_required"
                            label="回答文字数制限"
                            outlined
                            class="number-input pr-2"
                            :error-messages="errors[0]"
                            dense
                            :counter="4"
                            hide-details="auto"
                            @blur="formatNum(questionListStudent, question)"
                            :disabled="questionDisabled"
                          >
                            <template v-slot:append>
                              <div class="my-1 text-caption">
                                文字
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                  </div>

                  <!-- チェックボックス回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '1'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.etcInputFlg" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              その他入力を追加する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListStudent, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <!-- 設問 -->
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <!-- 選択肢 -->
                    <ValidationProvider v-for="checkOption in question.option" :key="checkOption.id" name="選択肢" rules="required|max:50" v-slot="{ errors }">
                      <v-row  no-gutters>
                        <v-col cols="12" class="d-flex py-0">
                          <v-checkbox placeholder="" dense hide-details disabled background-color="grey lighten-2"></v-checkbox>
                          <v-text-field
                            v-model="checkOption.title"
                            prepend-icon="$cet_required"
                            label="選択肢"
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="50"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-text-field>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" x-small v-if="checkOption.id != 0" class="ma-2 warning" @click="removeCheckOption(questionListStudent, question.id, checkOption.id)" :disabled="questionDisabled">
                                <v-icon>mdi-minus</v-icon>
                              </v-btn>
                            </template>
                            <span>選択肢を削除します</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <v-row no-gutters v-if="question.etcInputFlg == true">
                      <v-col cols="12" class="d-flex py-0">
                        <v-checkbox placeholder="" dense hide-details disabled background-color="grey lighten-2"></v-checkbox>
                        <div class="pa-2">
                          その他
                        </div>
                        <v-text-field
                          label="回答者の自由入力"
                          outlined
                          dense
                          disabled
                          :counter="50"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- 追加ボタン -->
                    <v-row no-gutters>
                      <v-col cols="12" class="d-flex justify-end py-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" x-small class="mx-2 mb-2 primary" @click="addCheckOption(questionListStudent, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>選択肢を追加します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- ラジオボタン回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '2'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.etcInputFlg" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              その他入力を追加する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListStudent, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <!-- 設問 -->
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <!-- 選択肢 -->
                    <ValidationProvider v-for="radioOption in question.option" :key="radioOption.id" name="選択肢" rules="required|max:50" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="d-flex py-0">
                          <v-radio-group class="align-start mt-1" background-color="grey lighten-2">
                            <v-radio dense hide-details disabled />
                          </v-radio-group>
                          <v-text-field
                            v-model="radioOption.title"
                            prepend-icon="$cet_required"
                            label="選択肢"
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="50"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-text-field>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" x-small v-if="radioOption.id > 1" class="ma-2 warning" @click="removeRadioOption(questionListStudent, question.id, radioOption.id)" :disabled="questionDisabled">
                                <v-icon>mdi-minus</v-icon>
                              </v-btn>
                            </template>
                            <span>選択肢を削除します</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <v-row no-gutters v-if="question.etcInputFlg == true">
                      <v-col cols="12" class="d-flex py-0">
                        <v-radio-group class="align-start mt-1" background-color="grey lighten-2">
                          <v-radio dense hide-details disabled />
                        </v-radio-group>
                        <div class="pa-2">
                          その他
                        </div>
                        <v-text-field
                          label="回答者の自由入力"
                          outlined
                          dense
                          disabled
                          :counter="50"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- 追加ボタン -->
                    <v-row no-gutters>
                      <v-col cols="12" class="d-flex justify-end py-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" x-small class="mx-2 mb-2 primary" @click="addRadioOption(questionListStudent, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>選択肢を追加します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- １行回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '3'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListStudent, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <!-- 設問 -->
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <ValidationProvider name="回答文字数制限" rules="required|numeric|max:4" v-slot="{ errors }">
                      <v-row  no-gutters>
                        <v-col cols="12" class="pr-0">
                          <v-text-field
                            v-model="question.charLimit"
                            prepend-icon="$cet_required"
                            label="回答文字数制限"
                            outlined
                            class="number-input pr-2"
                            :error-messages="errors[0]"
                            dense
                            :counter="4"
                            hide-details="auto"
                            @blur="formatNum(questionListStudent, question)"
                            :disabled="questionDisabled"
                          >
                            <template v-slot:append>
                              <div class="my-1 text-caption">
                                文字
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </ValidationProvider>

                    <ValidationProvider name="入力チェック" rules="required" v-slot="{ errors }" :skipIfEmpty="false">
                      <v-row  no-gutters>
                        <v-col cols="12" class="pr-2">
                          <v-select
                            label="入力チェック"
                            :items="checkTypeList"
                            class="pb-2"
                            item-text="name"
                            item-value="code"
                            v-model="question.checkType"
                            :error-messages="errors[0]"
                            outlined
                            dense
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                  </div>

                  <!-- 日付回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '4'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListStudent, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                  </div>
                </v-card>

                <v-row no-gutters>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputRadio(questionListStudent)" :disabled="questionDisabled">
                      <div>＋[単選択型]設問追加</div>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputCheck(questionListStudent)" :disabled="questionDisabled">
                      <div>＋[複数選択型]設問追加</div>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputText(questionListStudent)" :disabled="questionDisabled">
                      <div>＋[文章型]設問追加</div>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputLineText(questionListStudent)" :disabled="questionDisabled">
                      <div>＋[一行型]設問追加</div>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputDate(questionListStudent)" :disabled="questionDisabled">
                      <div>＋[日付型]設問追加</div>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="background-color: #FFFFCC;">
              <v-expansion-panel-header>
                <div style="font-size:x-large">教職員向け入力項目</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>

                <!-- 明細定義 -->
                <v-card v-for="(question, index) in questionListTeacher" :key="question.id" class="ml-0 mt-0 mb-4">
                
                  <!-- 文章回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '0'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="question.viewOnlyTeacher" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              生徒・保護者に表示する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListTeacher, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <!-- 設問 -->
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <ValidationProvider name="回答文字数制限" rules="required|numeric|max:4" v-slot="{ errors }">
                      <v-row  no-gutters>
                        <v-col cols="12" class="pr-0">
                          <v-text-field
                            v-model="question.charLimit"
                            prepend-icon="$cet_required"
                            label="回答文字数制限"
                            outlined
                            class="number-input pr-2"
                            :error-messages="errors[0]"
                            dense
                            :counter="4"
                            hide-details="auto"
                            @blur="formatNum(questionListStudent, question)"
                            :disabled="questionDisabled"
                          >
                            <template v-slot:append>
                              <div class="my-1 text-caption">
                                文字
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                  </div>

                  <!-- チェックボックス回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '1'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.etcInputFlg" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              その他入力を追加する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="question.viewOnlyTeacher" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              生徒・保護者に表示する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListTeacher, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <!-- 設問 -->
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <!-- 選択肢 -->
                    <ValidationProvider v-for="checkOption in question.option" :key="checkOption.id" name="選択肢" rules="required|max:50" v-slot="{ errors }">
                      <v-row  no-gutters>
                        <v-col cols="12" class="d-flex py-0">
                          <v-checkbox placeholder="" dense hide-details disabled background-color="grey lighten-2"></v-checkbox>
                          <v-text-field
                            v-model="checkOption.title"
                            prepend-icon="$cet_required"
                            label="選択肢"
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="50"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-text-field>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" x-small v-if="checkOption.id != 0" class="ma-2 warning" @click="removeCheckOption(questionListTeacher, question.id, checkOption.id)" :disabled="questionDisabled">
                                <v-icon>mdi-minus</v-icon>
                              </v-btn>
                            </template>
                            <span>選択肢を削除します</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <v-row no-gutters v-if="question.etcInputFlg == true">
                      <v-col cols="12" class="d-flex py-0">
                        <v-checkbox placeholder="" dense hide-details disabled background-color="grey lighten-2"></v-checkbox>
                        <div class="pa-2">
                          その他
                        </div>
                        <v-text-field
                          label="回答者の自由入力"
                          outlined
                          dense
                          disabled
                          :counter="50"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- 追加ボタン -->
                    <v-row no-gutters>
                      <v-col cols="12" class="d-flex justify-end py-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" x-small class="mx-2 mb-2 primary" @click="addCheckOption(questionListTeacher, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>選択肢を追加します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- ラジオボタン回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '2'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.etcInputFlg" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              その他入力を追加する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="question.viewOnlyTeacher" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              生徒・保護者に表示する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListTeacher, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <!-- 設問 -->
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <!-- 選択肢 -->
                    <ValidationProvider v-for="radioOption in question.option" :key="radioOption.id" name="選択肢" rules="required|max:50" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="d-flex py-0">
                          <v-radio-group class="align-start mt-1" background-color="grey lighten-2">
                            <v-radio dense hide-details disabled />
                          </v-radio-group>
                          <v-text-field
                            v-model="radioOption.title"
                            prepend-icon="$cet_required"
                            label="選択肢"
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="50"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-text-field>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" x-small v-if="radioOption.id > 1" class="ma-2 warning" @click="removeRadioOption(questionListTeacher, question.id, radioOption.id)" :disabled="questionDisabled">
                                <v-icon>mdi-minus</v-icon>
                              </v-btn>
                            </template>
                            <span>選択肢を削除します</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <v-row no-gutters v-if="question.etcInputFlg == true">
                      <v-col cols="12" class="d-flex py-0">
                        <v-radio-group class="align-start mt-1" background-color="grey lighten-2">
                          <v-radio dense hide-details disabled />
                        </v-radio-group>
                        <div class="pa-2">
                          その他
                        </div>
                        <v-text-field
                          label="回答者の自由入力"
                          outlined
                          dense
                          disabled
                          :counter="50"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <!-- 追加ボタン -->
                    <v-row no-gutters>
                      <v-col cols="12" class="d-flex justify-end py-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" x-small class="mx-2 mb-2 primary" @click="addRadioOption(questionListTeacher, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>選択肢を追加します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- １行回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '3'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="question.viewOnlyTeacher" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              生徒・保護者に表示する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListTeacher, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <!-- 設問 -->
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                    <ValidationProvider name="回答文字数制限" rules="required|numeric|max:4" v-slot="{ errors }">
                      <v-row  no-gutters>
                        <v-col cols="12" class="pr-0">
                          <v-text-field
                            v-model="question.charLimit"
                            prepend-icon="$cet_required"
                            label="回答文字数制限"
                            outlined
                            class="number-input pr-2"
                            :error-messages="errors[0]"
                            dense
                            :counter="4"
                            hide-details="auto"
                            @blur="formatNum(questionListStudent, question)"
                            :disabled="questionDisabled"
                          >
                            <template v-slot:append>
                              <div class="my-1 text-caption">
                                文字
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </ValidationProvider>

                    <ValidationProvider name="入力チェック" rules="required" v-slot="{ errors }" :skipIfEmpty="false">
                      <v-row  no-gutters>
                        <v-col cols="12" class="pr-2">
                          <v-select
                            label="入力チェック"
                            :items="checkTypeList"
                            class="pb-2"
                            item-text="name"
                            item-value="code"
                            v-model="question.checkType"
                            :error-messages="errors[0]"
                            outlined
                            dense
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                  </div>

                  <!-- 日付回答 -->
                  <div class="ml-2 mt-2" v-if="question.type == '4'">
                    <!-- ヘッダー -->
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex pl-3">
                        <div>{{ (index + 1) }} 問目：{{ question.typeName }}</div>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-end">
                        <v-checkbox v-model="question.required" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              回答必須に設定する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="question.viewOnlyTeacher" class="mt-0 mb-2 mr-2" dense hide-details :disabled="questionDisabled">
                          <template v-slot:label>
                            <div class="my-1 text-caption">
                              生徒・保護者に表示する
                            </div>
                          </template>
                        </v-checkbox>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small class="info mb-2 mr-2" @click="removeQuestion(questionListTeacher, question.id)" :disabled="questionDisabled">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                          </template>
                          <span>設問を削除します</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <ValidationProvider name="質問" rules="required|max:400" v-slot="{ errors }">
                      <v-row no-gutters>
                        <v-col cols="12" class="py-0 pr-2">
                          <v-textarea
                            v-model="question.content"
                            prepend-icon="$cet_required"
                            label="質問"
                            placeholder=""
                            :error-messages="errors[0]"
                            outlined
                            dense
                            :counter="400"
                            hide-details="auto"
                            :disabled="questionDisabled"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </ValidationProvider>
                  </div>
                </v-card>

                <v-row no-gutters>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputRadio(questionListTeacher)" :disabled="questionDisabled">
                      <div>＋[単選択型]設問追加</div>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputCheck(questionListTeacher)" :disabled="questionDisabled">
                      <div>＋[複数選択型]設問追加</div>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputText(questionListTeacher)" :disabled="questionDisabled">
                      <div>＋[文章型]設問追加</div>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputLineText(questionListTeacher)" :disabled="questionDisabled">
                      <div>＋[一行型]設問追加</div>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="d-flex justify-center mb-0">
                    <v-btn small class="ma-2 primary" @click="addInputDate(questionListTeacher)" :disabled="questionDisabled">
                      <div>＋[日付型]設問追加</div>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions class="d-flex mx-2 justify-center">
          <v-btn color="grey" class="mr-auto mt-0 black--text" @click="cancelCertificateEdit"  width="45%">戻る</v-btn>
          <v-btn color="accent" v-if="create" class="mt-0 black--text" @click="saveCertificateEdit" :disabled="invalid" width="45%">登録</v-btn>
          <v-btn color="accent" v-if="!create" class="ml-auto mt-0 black--text" @click="saveCertificateEdit" :disabled="invalid" width="45%">更新</v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
    <!-- 共同編集者グループ引きダイアログ -->
    <v-dialog
      v-model="viewEditAllowIdSetDialog"
      max-width="700"
      min-height="120"
      persistent
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="viewEditAllowIdSetDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              共同編集者を指定グループから設定する
            </v-col>
            <v-col cols="2" justify="center">
              <v-btn color="accent" class="black--text" @click="changeEditAllowIds()" width="90%">
                反映
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text class="d-flex justify-center flex-column">
          <v-row dense>
            <v-col dense cols="12" justify="center">
              <v-autocomplete
                v-model="editAllowGroupId"
                :items="groups"
                item-text="groupName"
                item-value="groupId"
                multiple
                chips
                deletable-chips
                outlined
                dense
              >
                <template v-slot:item="{ item }">
                  <v-checkbox
                    :input-value="editAllowGroupId.includes(item.groupId)"
                    hide-details
                    dense
                    class="ma-0 pa-0"
                  >
                    <template v-slot:label>
                      <span class="d-flex justify-space-between align-center">
                        {{ item.groupName }}
                        <v-tooltip v-if="item.favoriteFlg" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" color="orange" small>mdi-star</v-icon>
                          </template>
                          <span>お気に入り</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-checkbox>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 通知先グループ引きダイアログ -->
    <v-dialog
      v-model="viewNoticeIdSetDialog"
      max-width="700"
      min-height="120"
      persistent
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="viewNoticeIdSetDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              通知先を指定グループから設定する
            </v-col>
            <v-col cols="2" justify="center">
              <v-btn color="accent" class="black--text" @click="changeNoticeIds()" width="90%">
                反映
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-text class="d-flex justify-center flex-column">
          <v-row dense>
            <v-col dense cols="12" justify="center">
              <v-autocomplete
                v-model="noticeGroupId"
                :items="groups"
                item-text="groupName"
                item-value="groupId"
                multiple
                chips
                deletable-chips
                outlined
                dense
              >
                <template v-slot:item="{ item }">
                  <v-checkbox
                    :input-value="noticeGroupId.includes(item.groupId)"
                    hide-details
                    dense
                    class="ma-0 pa-0"
                  >
                    <template v-slot:label>
                      <span class="d-flex justify-space-between align-center">
                        {{ item.groupName }}
                        <v-tooltip v-if="item.favoriteFlg" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" color="orange" small>mdi-star</v-icon>
                          </template>
                          <span>お気に入り</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-checkbox>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { format } from 'date-fns';
import { ja } from 'date-fns/locale';

import * as Validator from 'validatorjs';
Validator.useLang('ja');

import { httpsCallable, getFunctions } from "firebase/functions";

export default {
  props: [
    'id',
    'ParamSelectedUserKbn',
    'ParamEditAllowIds',
    'ParamNoticeIds',
    'ParamTitle',
    'ParamBody',
    'ParamOpenDate',
    'ParamCloseDate',
    'ParamQuestionListSP',
    'ParamQuestionListTeacher',
  ],
  data() {
    return {
      // 新規作成フラグ
      create: true,
      lockOpenDateFlg: false,
      questionDisabled: false,

      // 対象グループ候補
      groups: [],

      // 共同編集者グループ引きダイアログ
      viewEditAllowIdSetDialog: false,
      editAllowGroupId: [],

      // 通知先グループ引きダイアログ
      viewNoticeIdSetDialog: false,
      noticeGroupId:[],

      // 対象ユーザー区分
      selectedUserKbn: ["0","1"],

      orderNo: 0,
      title: "",
      body: "",
      openDate: "" ,
      closeDate : "",

      // 生徒・保護者向け入力項目
      questionListStudent:[],
      // 教員向け入力項目
      questionListTeacher:[],

      // 共同編集者ID
      editAllowIds: [],
      noticeIds: [],
      teacherList: [],
      teacherIncludeList: [],

      checkTypeList:[
        { code: "0", name: "文字数制限のみ" },
        { code: "1", name: "文字数＋半角数字限定" },
        { code: "2", name: "文字数＋半角英数限定" },
      ],

    };
  },
  watch: {
    id: async function () {
      await this.reload();
    },
  },
  async created() {
    this.reload();
  },
  methods: {
    async reload() {
      // ローディング開始
      this.$root.loading = true;
      this.defaultDateSet();
      // 既存フォーム編集の場合
      if(this.ParamSelectedUserKbn)this.selectedUserKbn = Array.from(this.ParamSelectedUserKbn);
      if(this.ParamEditAllowIds)this.editAllowIds = this.ParamEditAllowIds;
      if(this.ParamNoticeIds)this.noticeIds = this.ParamNoticeIds;
      if(this.paramTitle)this.title = this.paramTitle;
      if(this.paramBody)this.body = this.paramBody;
      if(this.paramOpenDate)this.openDate = this.paramOpenDate;
      if(this.paramCloseDate)this.closeDate = this.paramCloseDate;
      if(this.paramQuestionListSP)this.questionListStudent = this.paramQuestionListSP;
      if(this.paramQuestionListT)this.questionListTeacher = this.paramQuestionListT;
      this.lockOpenDateFlg = false;
      this.questionDisabled = false;

      // グループの取得
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined({funcName:"loadGroupSelect"}).then((groups) => {
        let ret = [];
        groups.data.forEach((group) => {
          const row = {
            groupId : group.groupId,
            groupName: group.groupName,
            favoriteFlg: group.favoriteFlg,
          };
          ret.push(row);
        });
        this.groups = ret;
      });

      // 教員リストの取得（本人含まない）
      await schoolAidHomeLogined({funcName: "commonGetTeachers", includeFlg: false}).then((ret) => {
        this.teacherList = ret.data.teacherList;
      })
      // 教員リストの取得（本人含む）
      await schoolAidHomeLogined({funcName: "commonGetTeachers", includeFlg: true}).then((ret) => {
        this.teacherIncludeList = ret.data.teacherList;
      })

      if (this.id) {
        // 編集画面
        const data = {
          funcName: "loadCertificateRequestTemplateEdit",
          certificateId: this.id
        };
        await schoolAidHomeLogined(data).then((ret) => {
          this.selectedUserKbn = ret.data.selectedUserKbn;
          this.editAllowIds = ret.data.editAllowIds;
          this.noticeIds = ret.data.noticeIds;
          this.orderNo = ret.data.orderNo;
          this.title = ret.data.title;
          this.body = ret.data.body;
          this.openDate = ret.data.openDate;
          this.closeDate = ret.data.closeDate;
          this.questionListStudent = ret.data.questionListStudent;
          this.questionListTeacher = ret.data.questionListTeacher;
          this.questionDisabled = ret.data.questionDisabled;
          this.lockOpenDateFlg = ret.data.lockOpenDateFlg;
        })
        this.create = false;
      } else {
        // 新規登録
        this.create = true;
      }

      this.$root.loading = false;
      window.scrollTo(0,0);
    },

    // 共同編集者IDのグループ指定
    async changeEditAllowIds(){
      if(this.editAllowIds.length > 0){
        const result = confirm("共同編集者を変更してよろしいですか？");
        if (!result) {
          return;
        }
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      const param = {
        funcName:"getTeacherIdsForGroupIds",
        groupId: this.editAllowGroupId,
        getLoginUser: false,
      }
      await schoolAidHomeLogined(param).then((ret) => {
        this.editAllowIds = ret.data;
      });
      this.viewEditAllowIdSetDialog = false;
    },

    // 通知先IDのグループ指定
    async changeNoticeIds(){
      if(this.noticeIds.length > 0){
        const result = confirm("通知先を変更してよろしいですか？");
        if (!result) {
          return;
        }
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      const param = {
        funcName:"getTeacherIdsForGroupIds",
        groupId: this.noticeGroupId,
        getLoginUser: true,
      }
      await schoolAidHomeLogined(param).then((ret) => {
        this.noticeIds = ret.data;
      });
      this.viewNoticeIdSetDialog = false;
    },

    // テキスト回答の設問追加
    addInputText (questionList) {
      let createId;
      if (questionList.length == 0) {
        createId = 0;
      } else {
        const lastElem = questionList.slice(-1)[0];
        createId = lastElem.id + 1;
      }
      const row = {
        id: createId,
        content: "",
        type: "0",
        typeName: "[文章型]設問",
        charLimit: "",
        required: false,
        checkType: "",
        etcInputFlg: false,
        viewOnlyTeacher: false,
        option: [],
      };
      questionList.push(row);
    },

    // チェックボックス回答の設問追加
    addInputCheck (questionList) {
      let createId;
      if (questionList.length == 0) {
        createId = 0;
      } else {
        const lastElem = questionList.slice(-1)[0];
        createId = lastElem.id + 1;
      }
      const row = {
        id: createId,
        content: "",
        type: "1",
        typeName: "[複数選択型]設問",
        charLimit: null,
        required: false,
        checkType: "",
        etcInputFlg: false,
        viewOnlyTeacher: false,
        option: [{
          id : 0,
          title : "",
        }],
      };
      questionList.push(row);
    },

    // ラジオボタン回答の設問追加
    addInputRadio (questionList) {
      let createId;
      if (questionList.length == 0) {
        createId = 0;
      } else {
        const lastElem = questionList.slice(-1)[0];
        createId = lastElem.id + 1;
      }
      const row = {
        id : createId,
        content: "",
        type: "2",
        typeName: "[単選択型]設問",
        charLimit: null,
        required: true,
        checkType: "",
        etcInputFlg: false,
        viewOnlyTeacher: false,
        option: [{
          id : 0,
          title : "",
        },
        {
          id : 1,
          title : "",
        }],
      };
      questionList.push(row);
    },

    // テキスト(１行)回答の設問追加
    addInputLineText (questionList) {
      let createId;
      if (questionList.length == 0) {
        createId = 0;
      } else {
        const lastElem = questionList.slice(-1)[0];
        createId = lastElem.id + 1;
      }
      const row = {
        id: createId,
        content: "",
        type: "3",
        typeName: "[一行型]設問",
        charLimit: "",
        required: false,
        checkType: "0",
        etcInputFlg: false,
        viewOnlyTeacher: false,
        option: [],
      };
      questionList.push(row);
    },

    // 日付型回答の設問追加
    addInputDate (questionList) {
      let createId;
      if (questionList.length == 0) {
        createId = 0;
      } else {
        const lastElem = questionList.slice(-1)[0];
        createId = lastElem.id + 1;
      }
      const row = {
        id: createId,
        content: "",
        type: "4",
        typeName: "[日付型]設問",
        charLimit: null,
        required: false,
        checkType: "0",
        etcInputFlg: false,
        viewOnlyTeacher: false,
        option: [],
      };
      questionList.push(row);
    },

    // 設問削除
    removeQuestion (questionList, id) {
      const index = questionList.findIndex(item => item.id == id);
      if (index !== -1) questionList.splice(index, 1);
    },

    // チェックボックス選択肢追加
    addCheckOption (questionList, id) {
      const index = questionList.findIndex(item => item.id == id);
      let createId;
      if (questionList[index].option.length == 0) {
        createId = 0;
      } else {
        const lastElem = questionList[index].option.slice(-1)[0];
        createId = lastElem.id + 1;
      }
      const row = {
        id : createId,
        title : "",
      };
      questionList[index].option.push(row);
    },

    // ラジオボタン選択肢追加
    addRadioOption (questionList, id) {
      const index = questionList.findIndex(item => item.id == id);
      let createId;
      if (questionList[index].option.length == 0) {
        createId = 0;
      } else {
        const lastElem = questionList[index].option.slice(-1)[0];
        createId = lastElem.id + 1;
      }
      const row = {
        id : createId,
        title : "",
      };
      questionList[index].option.push(row);
    },

    // チェックボックス選択肢削除
    removeCheckOption (questionList, questionId, checkId) {
      const index = questionList.findIndex(item => item.id == questionId);
      questionList[index].option = questionList[index].option.filter(function(item) {
        return item.id != checkId;
      });
    },

    // ラジオボタン選択肢削除
    removeRadioOption (questionList, checkId, radioId) {
      const index = questionList.findIndex(item => item.id == checkId);
      questionList[index].option = questionList[index].option.filter(function(item) {
        return item.id != radioId;
      });
    },

    // 申請フォーマット登録
    async saveCertificateEdit() {
      if(this.selectedUserKbn.length == 0){
        alert("対象ユーザー区分を選択してください");
        return;
      }

      for (let i = 0; i < this.questionListStudent.length; i++) {
        if (this.questionListStudent[i].type == "1" || this.questionListStudent[i].type == "2") {
          if (this.questionListStudent[i].option.length == 0){
            alert("選択肢を作成してください。");
            return;
          }
        }
      }

      for (let i = 0; i < this.questionListTeacher.length; i++) {
        if (this.questionListTeacher[i].type == "1" || this.questionListTeacher[i].type == "2") {
          if (this.questionListTeacher[i].option.length == 0){
            alert("選択肢を作成してください。");
            return;
          }
        }
      }

      if (this.questionListStudent.length == 0) {
        alert("設問を作成してください");
        return;
      }
      // ローディング表示
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      if (this.create) {
        // 新規登録
        const createData = {
          funcName: "createCertificateRequestTemplateEdit",
          title : this.title,
          body : this.body,
          openDate : this.openDate,
          closeDate : this.closeDate,
          selectedUserKbn : this.selectedUserKbn,
          questionListStudent : this.questionListStudent,
          questionListTeacher : this.questionListTeacher,
          editAllowIds: this.editAllowIds,
          noticeIds: this.noticeIds,
          orderNo: this.orderNo,
        };
        await schoolAidHomeLogined(createData).then((res) => {
          // ローディング非表示
          this.$root.loading = false;
          if (res.data == "success"){
            alert("登録しました。");
            this.$router.push({
              name: "CertificateRequestTemplateList",
            });
          } else {
            alert(res.data);
          }
        });
      } else {
        // 更新
        const updateData = {
          funcName: "updateCertificateRequestTemplateEdit",
          certificateId : this.id,
          title : this.title,
          body : this.body,
          openDate : this.openDate,
          closeDate : this.closeDate,
          selectedUserKbn : this.selectedUserKbn,
          questionListStudent : this.questionListStudent,
          questionListTeacher : this.questionListTeacher,
          editAllowIds: this.editAllowIds,
          noticeIds: this.noticeIds,
          orderNo: this.orderNo,
        };
        await schoolAidHomeLogined(updateData).then((res) => {
          // ローディング非表示
          this.$root.loading = false;
          if (res.data == "success"){
            alert("登録しました。");
            this.$router.push({
              name: "CertificateRequestTemplateList",
            });
          } else {
            alert(res.data);
          }
        });
      }
    },
    // 戻るボタン
    cancelCertificateEdit(){
      this.$router.push({
        name: "CertificateRequestTemplateList",
      });
    },
    // 公開開始/終了の初期値設定
    defaultDateSet() {
      let dt = new Date() ;
      const dtFrom = new Date(dt.setDate(dt.getDate() + 1));
      this.openDate = this.formatDate(dtFrom)  + "T07:00";
      
      dt = new Date() ;
      const dtTo =new Date( dt.setMonth(dt.getMonth()+1)) ;
      this.closeDate = this.formatDate(dtTo) + "T23:59";
      console.log("1月後",this.closeDate);
    } ,
    setFastOpen() {
      let dt = new Date() ;
      dt.setMinutes(dt.getMinutes() + 3);
      this.openDate = format(dt, "yyyy-MM-dd'T'HH:mm", { locale: ja });
    },
    formatDate(dt){
      const y = dt.getFullYear();
      const m = ('00' + (dt.getMonth()+1)).slice(-2);
      const d = ('00' + dt.getDate()).slice(-2);
      return (y + '-' + m + '-' + d);
    },
    formatNum(questionList, item){
      let num = parseInt(item.charLimit);
      if (Number.isNaN(num) || num < 1) {
        num = "";
      }
      for (const question of questionList) {
        if (item.id == question.id) {
          question.charLimit = num;
          break;
        }
      }
    },
    formatOrderNo(orderNo){
      const fullnums = '０１２３４５６７８９';
      const toHalfnums = text => text.replace(/[０-９]/g, m=>fullnums.indexOf(m));
      let orderNoInt = parseInt(toHalfnums(orderNo));
      if (Number.isNaN(orderNoInt) || orderNoInt < 0) {
        return orderNo;
      } else {
        return orderNoInt;
      }
    },
    // 申請フォーマットをコピーして新規作成
    onClickCopyTemplate() {
      this.$router.push({
        name: "CertificateRequestTemplateEdit",
        params: {
          id : "",
          ParamSelectedUserKbn : this.selectedUserKbn,
          ParamEditAllowIds : this.editAllowIds,
          ParamNoticeIds : this.noticeIds,
          ParamTitle : this.title,
          ParamBody : this.body,
          ParamOpenDate : this.openDate,
          ParamCloseDate : this.closeDate,
          ParamQuestionListSP : this.questionListStudent,
          ParamQuestionListTeacher : this.questionListTeacher,
        }
      });
    },
  },
};
</script>

<style scoped>
.number-input >>> input {
  text-align: right
}
</style>